export default __webpack_public_path__ + "static/splitshank-5ee948179a6c7c1e213ca1d078652cfe.png";